const isAbortControllerSupported = typeof AbortController !== 'undefined'

export const createAbortController = () =>
  isAbortControllerSupported ? new AbortController() : undefined
